import type { EnvironmentProviders } from '@angular/core';
import { provideStates } from '@ngxs/store';

import { LookupTypesState } from './states';

export function provideEspLookupTypesDataAccess(): EnvironmentProviders {
  return provideStates([LookupTypesState]);
}
